import lazyLoad from '@utils/lazyLoad'
import code from '@enum/applicationCode'
const applicationCode = code.member

const routes = [
  {
    path: '/members/potentialCustomers/customersList',
    exact: true,
    component: lazyLoad(() => import('@views/Members/PotentialCustomers/CustomersList/customersList')),
    meta: {
      applicationCode,
      title: '客户管理',
      layoutMode: 'empty'
    }
  },
  {
    path: '/members/potentialCustomers/customersList/detail',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/PotentialCustomers/CustomersList/customersDetail')
    ),
    meta: {
      applicationCode,
      title: '客户详情'
    }
  },
  {
    path: '/members/potentialCustomers/customersList/edit',
    exact: true,
    component: lazyLoad(() => import('@views/Members/PotentialCustomers/CustomersList/customersEdit')),
    meta: {
      applicationCode,
      title: '编辑客户'
    }
  },
  {
    path: '/members/potentialCustomers/weFans/weFans',
    exact: true,
    component: lazyLoad(() => import('@views/Members/PotentialCustomers/WeFans/WeFans')),
    meta: {
      applicationCode,
      title: '微信粉丝管理',
      layoutMode: 'empty'
    }
  },
  {
    path: '/members/potentialCustomers/weFans/list',
    exact: true,
    component: lazyLoad(() => import('@views/Members/PotentialCustomers/WeFans/WeFansList')),
    meta: {
      applicationCode,
      title: '微信粉丝管理',
      layoutMode: 'empty'
    }
  },
  {
    path: '/members/management/memberList',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Management/MemberList/MemberList')),
    meta: {
      applicationCode,
      title: '会员管理',
      layoutMode: 'empty'
    }
  },
  {
    path: '/members/management/memberList/edit',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Management/Edit/Edit')
    ),
    meta: {
      applicationCode,
      title: '编辑会员'
    }
  },
  {
    path: '/members/management/memberList/add',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Management/Add/Add')),
    meta: {
      applicationCode,
      title: '新建会员'
    }
  },
  {
    path: '/members/management/memberList/detail/:id/:brandId',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Management/Detail/Detail')),
    meta: {
      applicationCode,
      title: '会员详情'
    }
  },
  {
    path: '/members/Loyalty/points/points_management',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Loyalty/Points')
    ),
    meta: {
      title: '积分管理'
    }
  },
  {
    path: '/members/loyalty/level',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Loyalty/Level')
    ),
    meta: {
      layoutMode: 'empty',
      title: '会员等级管理'
    }
  },
  {
    path: '/members/loyalty/level/edit',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Loyalty/Level/Edit')
    ),
    meta: {
      layoutMode: 'empty',
      title: '会员等级管理编辑'
    }
  },
  {
    path: '/members/loyalty/blacklist',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Loyalty/Blacklist/EquitiesBlackList')
    ),
    meta: {
      applicationCode,
      title: '权益黑名单',
      layoutMode: 'empty'
    }
  }
]

export default routes
